import React, { useEffect } from 'react';
import './About.css';

export default function About(){
  useEffect(()=>{
    document.title = 'About Us — SocialManiacs';
  },[]);

  return (
    <div className="about-page">
      <div className="hero-min-bg" aria-hidden="true">
        <svg className="bg-lines" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M -50 200 Q 100 100, 300 50" className="bg-arc" />
          <path d="M 700 -50 Q 850 100, 1000 300" className="bg-arc" />
          <path d="M 400 300 Q 600 250, 800 300" className="bg-arc center" />
        </svg>
        {/* Yellow blobs */}
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />
        <div className="blob blob-4" />
        <div className="blob blob-5" />
        {/* Gray geometric shapes */}
        <div className="geom geom-1" />
        <div className="geom geom-2" />
        <div className="geom geom-3" />
        <div className="geom geom-4" />
        <div className="geom geom-5" />
        {/* Circle outlines */}
        <div className="ring ring-1" />
        <div className="ring ring-2" />
        {/* Small dots */}
        <div className="dots">
          <span className="dot dot-1" />
          <span className="dot dot-2" />
          <span className="dot dot-3" />
          <span className="dot dot-4" />
          <span className="dot dot-5" />
          <span className="dot dot-6" />
          <span className="dot dot-7" />
          <span className="dot dot-8" />
          <span className="dot dot-9" />
          <span className="dot dot-10" />
          <span className="dot dot-11" />
          <span className="dot dot-12" />
          <span className="dot dot-13" />
          <span className="dot dot-14" />
        </div>
      </div>
      {/* Hero Section with Quote and About Card */}
      <section className="about-hero py-5">
        <div className="container">
          <div className="row g-4 align-items-center">
            {/* Left Side - Quote */}
            <div className="col-lg-6 scroll-reveal">
              <div className="quote-card">
                <div className="quote-icon">
                  <i className="bi bi-quote"></i>
                </div>
                <p className="quote-text">
                   Born of a shared commitment to excellence, our 
                  team is dedicated to transforming your concepts 
                  into reality. We adhere rigorously to project timelines 
                  and budgetary considerations, providing steadfast 
                  support throughout, with the aim of surpassing your 
                  strategic objectives.
                </p>
                <div className="quote-image">
                  <img src="/images/ab1.png" alt="Workspace" onError={(e) => {
                    e.target.style.display = 'none';
                  }} />
                </div>
              </div>
            </div>

            {/* Right Side - About Us Card */}
            <div className="col-lg-6 scroll-reveal">
              <div className="about-card">
                <div className="about-card-header">
                  <h2>ABOUT US</h2>
                  <div className="about-icon">
                    <i className="bi bi-gear-fill"></i>
                  </div>
                </div>
                <div className="about-card-content">
                  <p>
                     At SocialManiacs, we're more than a marketing agency; 
                    we're architects of compelling brand narratives, sculptors 
                    of engaging content, and navigators in the realm of digital 
                    innovation.
                    
                  </p>
                  <p>
                    Our suite of services encompasses cutting-edge digital 
                    marketing solutions, innovative designs, creative 
                    endeavors, and avant-garde branding strategies and 
                    impactful below-the-line (BTL) activities.. Despite our 
                    youthful energy, we infuse every project with a fresh 
                    perspective and unrestrained passion.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     

      {/* Vision & Mission Section */}
      <section className="vision-mission-section py-5">
        <div className="container">
          <div className="row g-4">
            {/* Vision Card */}
            <div className="col-lg-4 scroll-reveal">
              <div className="vm-card">
                <div className="vm-header">
                  <h3>VISION</h3>
                  <div className="vm-icon">
                    <i className="bi bi-eye-fill"></i>
                  </div>
                </div>
                <div className="vm-content">
                  <p>
                     At SocialManiacs, we uphold the significance of 
                    actively listening to your concepts, transforming them 
                    into compelling content, captivating presentations, 
                    and immersive interactive experiences. 
                  </p>
                  <p>
                    Our expertise 
                    lies in the strategic utilization of customer insights to 
                    elevate and optimize the experiences that your brand 
                    offers.
                  </p>
                </div>
              </div>
            </div>

            {/* Mission Card */}
            <div className="col-lg-4 scroll-reveal">
              <div className="vm-card">
                <div className="vm-header">
                  <h3>MISSION</h3>
                  <div className="vm-icon">
                    <i className="bi bi-bullseye"></i>
                  </div>
                </div>
                <div className="vm-content">
                  <p>
                    To deliver exceptional digital marketing solutions that drive measurable results, 
                    combining creativity with data-driven strategies to help our clients thrive in the 
                    digital landscape.
                  </p>
                  <p>
                    We are committed to building long-term partnerships based on trust, transparency, 
                    and delivering value that exceeds expectations.
                  </p>
                </div>
              </div>
            </div>

            {/* Image Card */}
            <div className="col-lg-4 scroll-reveal">
              <div className="vm-image-card">
                <img src="/images/marketing.png" alt="Our Mission" onError={(e) => {
                  e.target.style.background = 'white';
                  e.target.style.display = 'flex';
                  e.target.style.alignItems = 'center';
                  e.target.style.justifyContent = 'center';
                  e.target.innerHTML = '<i class="bi bi-laptop" style="font-size: 4rem; color: #a9a9a9;"></i>';
                }} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section py-5">
        <div className="container">
          <div className="text-center mb-5 scroll-reveal">
            <h2 className="section-title">Our <span className="gradient-text">Core Values</span></h2>
            <p className="section-subtitle">At the heart of SocialManiacs, we believe in the power of creativity, innovation, and collaboration. Our core values guide everything we do and shape the way we work with our clients. These values drive us to create exceptional results that resonate deeply with our clients and their audiences.</p>
          </div>
          <div className="row g-4 justify-content-center">
            <div className="col-md-6 col-lg-3 scroll-reveal">
              <div className="value-card">
                <div className="value-icon">
                  <i className="bi bi-palette-fill"></i>
                </div>
                <h4>Creativity</h4>
                <p>We push the boundaries of what’s possible, crafting solutions that not only stand out but leave a lasting impact.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 scroll-reveal">
              <div className="value-card">
                <div className="value-icon">
                  <i className="bi bi-lightbulb-fill"></i>
                </div>
                <h4>Innovation</h4>
                <p>The digital landscape is ever-evolving, and we thrive on staying ahead of trends, constantly adapting to new technologies and strategies.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 scroll-reveal">
              <div className="value-card">
                <div className="value-icon">
                  <i className="bi bi-people-fill"></i>
                </div>
                <h4>Collaboration</h4>
                <p>We believe in the power of partnership. By working closely with our clients, we build tailored solutions that reflect their brand’s unique story.</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 scroll-reveal">
              <div className="value-card">
                <div className="value-icon">
                  <i className="bi bi-heart-fill"></i>
                </div>
                <h4>Passion</h4>
                <p>Every project we take on is infused with unbridled enthusiasm and a commitment to excellence.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="section-sep" />
    </div>
  );
}